module.exports = {
  API_URL: process.env.REACT_APP_API_URL,
  STORAGE_URL: process.env.REACT_APP_STORAGE_URL,
  API_URL_LS: process.env.REACT_APP_API_URL_LS,
  API_URL_FE_LS: process.env.REACT_APP_API_URL_FE_LS
};
